export const isOnPointsGroup = location.origin.includes('.pointsgroup.');
